import React, { Component } from 'react';
import './Footer.css';


class Footer extends Component {

    constructor(props) {
        super(props);

        this.handleDseClick = this.handleDseClick.bind(this);
        this.handleImprintClick = this.handleImprintClick.bind(this);
    }

    handleDseClick(e) {
        e.preventDefault();
        this.props.changeRoute('dse');
    }

    handleImprintClick(e) {
        e.preventDefault();
        this.props.changeRoute('imprint');
    }

    render() {
        return (
            <footer id="footer">
                <ul>
                    <li>
                        <a className="no-select" target="_blank" rel="noopener noreferrer" href="https://www.novoferm-extranet.de/public/impressum.html">Impressum</a>
                    </li>
                    <li>
                        <a className="no-select" target="_blank" rel="noopener noreferrer" href="https://www.novoferm-extranet.de/public/datenschutzerklaerung.html">Datenschutzerklärung</a>
                    </li>
                </ul>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js